/**
 * Base entity model. All Apollon models should inherit this class.
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { BaseCollection, LookupCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';

export class Anrede extends BaseModel {
    id: number | null = null;
    bezeichnung: string | null = null;
    briefanrede: string | null = null;
    aktiv: boolean | null = false;
    erstellt_am: Dayjs | null = null;
    bearbeitet_am: Dayjs | null = null;
    ersteller_id: number | null = null;
    bearbeiter_id: number | null = null;
    reihenfolge: number | null = null;


    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            ersteller_id: (id) => (Number(id) > 0 ? Number(id) : null),
            bearbeiter_id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'anrede';
    }
}


export class AnredeCollection extends LookupCollection<Anrede> {
    protected modelCls = Anrede;

    public getModelClassName(): string {
        return 'anrede';
    }
}